export const italiano = {
    modulo: 'Archiviazione',
    archivi: {
        titolo: 'Archivi',
        descrizione: 'Visualizza i tuoi archivi',
    },
    filtro: {
        ricerca: "Ricerca",
        tipoDocumento: "Seleziona un tipo documento",
        anno: "Anno",
        mese: "Mese",
        mesi: [
            "Gennaio",
            "Febbraio",
            "Marzo",
            "Aprile",
            "Maggio",
            "Giugno",
            "Luglio",
            "Agosto",
            "Settembre",
            "Ottobre",
            "Novembre",
            "Dicembre"
        ]
    },
    dataTable: {
        tipoDocumento: "Tipo documento",
        numeroProtocollo: "Num. prot.",
        numeroProtocolloMobile: "Numero:",
        dataProtocollo: "Data prot.",
        dataProtocolloMobile: "Data:",
        sezionale: "Sez."
    },
    fileSelector: {
        titolo: 'Aggiungi delle immagini',
        noImageTitolo: 'Nessuna immagine',
        noImageDescrizione: 'Per aggiungere delle immagini premi il tasto +',
        imageOnly: 'Verranno accettati file solo di tipo immagine',
    }
}

export const inglese = {
    modulo: 'Archiviazione',
    archivi: {
        titolo: '',
        descrizione: '',
    },
    filtro: {
        ricerca: "Search",
        tipoDocumento: "Select a document type",
        anno: "Year",
        mese: "Month",
        mesi: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    dataTable: {
        tipoDocumento: "Document type",
        numeroProtocollo: "Protocol",
        numeroProtocolloMobile: "Protocol:",
        dataProtocollo: "Date",
        dataProtocolloMobile: "Date:",
        sezionale: "Sez."
    },
    fileSelector: {
        titolo: 'Aggiungi delle immagini',
        noImageTitolo: 'Nessuna immagine',
        noImageDescrizione: 'Per aggiungere delle immagini premi il tasto +',
        imageOnly: 'Verranno accettati file solo di tipo immagine',
    }
}